import { DcBaseComponent } from '@deleteagency/dc';
import { deviceObserver } from '@deleteagency/device-observer';

const MAX_HEIGHT = 500;

export default class GalleryComponent extends DcBaseComponent {
    static getNamespace() {
        return 'gallery';
    }

    onInit() {
        if (this.refs.cell) {
            this._calculateElements();
            this._layout();

            deviceObserver.subscribeOnResize(this._onResize);
        }
    }

    _onResize = () => {
        this._layout();
    };

    _calculateElements() {
        this.elements = this.refs.cell.map((cell) => {
            const w = parseInt(cell.getAttribute('data-w'));
            const h = parseInt(cell.getAttribute('data-h'));
            const r = h / w;

            return {
                el: cell,
                width: w,
                height: h,
                aspectRatio: r
            };
        });
    }

    _getWidth(row, width, height) {
        // resize an element so that it matches the height
        // of the row's first element, and return the width
        return (row.length > 1) ? Math.round(width * row[0].height / height) : width;
    }

    _layout() {
        const containerWidth = this.element.clientWidth;

        let row = [];
        let rowWidth = 0;
        let rowHeight = 0;
        let elementWidth = 0;
        let remainingWidth = 0;

        for (let i = 0; i < this.elements.length; i++) {
            // add element to end of row
            row.push(this.elements[i]);

            // update total row width
            rowWidth += this._getWidth(row, this.elements[i].width, this.elements[i].height);

            // calculate row height if the row was sized to 100% of container
            rowHeight = Math.round(row[0].width / rowWidth * containerWidth * row[0].aspectRatio);

            // is row height within bounds, or have we reached the last row?
            if (rowHeight <= MAX_HEIGHT || i === this.elements.length - 1) {
                // set remaining width to container width
                remainingWidth = containerWidth;

                for (let j = 0; j < row.length; j++) {
                    // calculate element width based on row height
                    elementWidth = Math.round(rowHeight / row[j].aspectRatio);

                    // if the calculated width is less than remaining,
                    // or if it's the last element in row,
                    // then set element width to remaining width
                    if (remainingWidth < elementWidth || j === row.length - 1) {
                        elementWidth = remainingWidth;
                    }

                    // apply width & height styles to element
                    row[j].el.style.width = `${elementWidth}px`;
                    row[j].el.style.height = `${rowHeight}px`;

                    // re-calculate remaining width
                    remainingWidth -= elementWidth;
                }

                // start a new row
                row = [];
                rowWidth = 0;
                rowHeight = 0;
                elementWidth = 0;
                remainingWidth = 0;
            }
        }
    }
}
